import { AppFlavour, getBrandingConfig } from '../config/app-config';
import MTLogo from '../images/apps/Materiality_Tracker_logo.svg';

export const materialityTrackerCardConfig = {
  title: 'Materiality Tracker',
  logo: MTLogo,
  color: '#69157211',
}

const ctlApp = getBrandingConfig(AppFlavour.DEFAULT).branding.ctlApp;
export const companyTrackerCardConfig = {
  title: 'Company Tracker',
  logo: ctlApp.cardLogo,
  color: '#E7380011',
};